<template>
  <div class="row items-center no-wrap">
    <q-btn
      no-caps
      unelevated
      v-if="isPaused"
      @click="setUnpause"
      class="col border-red"
      padding="4px 0"
      color="red"
      text-color="white"
    >
      <UnpauseMiniIcon />
      <span class="q-pl-sm text-label text-bold">Despausar</span>
    </q-btn>

    <q-btn
      no-caps
      unelevated
      class="col border-orange"
      padding="4px 0"
      v-else-if="hasSchedulePause"
      @click="clearSchedulePause"
      color="orange-9"
      text-color="white"
    >
      <span class="text-label text-bold">Não Pausar</span>
      <q-tooltip>Pausa será aplicada após o atendimento finalizar! Clique aqui para cancelar essa ação.</q-tooltip>
    </q-btn>

    <q-btn
      v-else
      no-caps
      unelevated
      class="col border"
      padding="4px 0"
      color="white"
      text-color="grey-8"
    >
      <q-menu>
        <q-list dense>
          <template v-for="reason in pauseReasons">
            <q-item
              dense
              clickable
              v-close-popup
              :key="reason.id"
              @click="setPause(reason.id)"
            >
              <q-item-section>{{ reason.description }}</q-item-section>
            </q-item>

            <q-separator :key="`separator-${reason.id}`" />
          </template>
        </q-list>
      </q-menu>

      <PauseMiniIcon class="q-mr-sm" />
      <span class="text-label">Pausar</span>
    </q-btn>

    <div class="col-auto">
      <q-btn
        size="sm"
        unelevated
        padding="4px"
        :icon="autoRejection ? 'mdi-bell-cancel' : 'mdi-bell-check'"
        :text-color="hasScheduleLogout || hasSchedulePause || isPaused ? 'grey-8' : (autoRejection ? 'red-8' : 'green-8')"
        @click="setAutoRejection(!autoRejection)"
        :disable="hasScheduleLogout || hasSchedulePause || isPaused"
        v-if="useDND"
      >
        <q-tooltip><span class="text-bold">{{ autoRejection ? '"Não perturbe" ativado' : '"Não perturbe" desativado' }}</span></q-tooltip>
      </q-btn>
      <span v-else>&nbsp;</span>
    </div>

    <q-btn
      v-if="hasScheduleLogout"
      no-caps
      unelevated
      class="col border-orange"
      padding="4px 0"
      color="orange-9"
      text-color="white"
      @click="clearScheduleLogout"
    >
      <span class="text-label text-bold">Não Deslogar</span>
      <q-tooltip>Deslogar será aplicado após o atendimento finalizar! Clique aqui para cancelar essa ação.</q-tooltip>
    </q-btn>

    <q-btn
      v-else
      no-caps
      unelevated
      class="col border"
      padding="4px 0"
      color="white"
      text-color="grey-8"
      @click="logout"
    >
      <LogoutMiniIcon class="q-mr-sm" />
      <span class="text-label">Deslogar</span>
    </q-btn>
  </div>
</template>

<script>
import PauseMiniIcon from '@/assets/icons/pauseMini.svg'
import LogoutMiniIcon from '@/assets/icons/logoutMini.svg'
import UnpauseMiniIcon from '@/assets/icons/unpauseMini.svg'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    PauseMiniIcon,
    LogoutMiniIcon,
    UnpauseMiniIcon
  },

  computed: {
    ...mapState({
      isPaused: ({ agentModule }) => Boolean(agentModule?.session?.agent?.paused),
      inAttendance: ({ agentModule }) => Boolean(agentModule?.session?.agent?.inAttendance),
      pauseReasons: ({ agentModule }) => agentModule.session.pauseReasons,
      autoRejection: ({ agentModule }) => Boolean(agentModule?.autoRejection),
      hasSchedulePause: ({ agentModule }) => Boolean(agentModule.session.schedulePause),
      hasScheduleLogout: ({ agentModule }) => Boolean(agentModule.session.scheduleLogout),

      useDND: ({ settingsModule }) => {
        const canUseDND = settingsModule?.provision?.canUseDND ?? false
        return canUseDND && settingsModule?.useDND === 'yes'
      }
    })
  },

  methods: {
    ...mapActions({
      logout: 'sipModule/logout',
      pause: 'sipModule/pause',
      unpause: 'sipModule/unpause',
      init: 'socketModule/init',
      setAutoRejection: 'agentModule/setAutoRejection',
      clearSchedulePause: 'agentModule/clearSchedulePause',
      clearScheduleLogout: 'agentModule/clearScheduleLogout'
    }),

    setPause (pauseReasonId) {
      this.pause(pauseReasonId)
    },

    setUnpause () {
      this.unpause()
      this.init()
    }
  }
}
</script>

<style lang="sass" scoped>
.text-label
  font-style: normal
  font-weight: normal
  font-size: 13px
  line-height: 15px

.text-label.text-bold
  font-weight: bold !important

.text-bold
  font-weight: bold !important

.border
  border: solid 1px #CFD8DC
  border-radius: 2px

.border-red
  border: solid 1px #ff0000
  border-radius: 2px

.border-orange
  border: solid 1px #ef6c00
  border-radius: 2px

</style>
